export default __webpack_public_path__ + "static/bat-girl-4e44b668eadcf440ae112508ee5a5baf.webp";